export function updateContainerChildrenX(containerGroup, x) {
    return containerGroup.forEachChildrenSkipChild(((column, index) => {
        column.setAttribute("x", x), x += column.attribute.width;
    })), x;
}
//# sourceMappingURL=update-container.js.map
